import { useCallback, useReducer } from "react";
import {
  DragAndDropContext,
  dragAndDropReducer,
  type IDrag,
} from "./DragAndDropContext";

type DragAndDropContextProviderProps = {
  children: React.ReactNode;
};

export const DragAndDropContextProvider = ({
  children,
}: DragAndDropContextProviderProps) => {
  const [state, dispatch] = useReducer(dragAndDropReducer, {
    drag: undefined,
    availableDropZones: {
      sidebar: false,
      route: false,
      shift: false,
    },
  });

  const startDrag = useCallback((drag: IDrag) => {
    dispatch({
      type: "START_DRAG",
      drag,
    });
  }, []);

  const endDrag = useCallback(() => {
    dispatch({ type: "END_DRAG" });
  }, []);

  return (
    <DragAndDropContext.Provider
      value={{
        drag: state.drag,
        availableDropZones: state.availableDropZones,
        startDrag,
        endDrag,
      }}
    >
      {children}
    </DragAndDropContext.Provider>
  );
};
